module.exports = __webpack_public_path__ + "static/img/stkip_tsbima.24ccb2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/stkip_tsbima.png
// module id = GSl3
// module chunks = 15